<div class="tag-container">
  <div class="tag-title">
    <span *ngIf="categoryName" class="property-name">{{ categoryName }}:&nbsp;</span>
    <span [ngClass]="{'nr-bold text-uppercase': categoryName}">
      {{ title }}
    </span>
  </div>
  <button 
    *ngIf="isFilter" 
    aria-label="remove filter" 
    class="nr-close nr-button-blue" 
    (click)="onRemoveFilter()"
  >
    <div class="close-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x close-svg" viewBox="0 0 16 16">
        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
      </svg>
    </div>
  </button>
</div>